import BaseFilter from "./base_filter"
import { createFormGroup, createSelect, createSummary } from "./dom"

export default class YesOrNoFilter extends BaseFilter {
  createForm() {
    super.createForm()

    this.input = createSelect([
      { value: "yes", label: this.context.translations.yes },
      { value: "no", label: this.context.translations.no },
    ])
    this.element.append(createFormGroup(this.definition.title, this.input))
    this.appendApplyButton()

    return this.element
  }

  read() { return this.result(this.input.value === "yes") }

  summary(value) {
    return createSummary(this.definition.title, value ? this.context.translations.yes : this.context.translations.no)
  }
}
